import React from 'react'
import styled from 'styled-components'

import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const NotificationSection = styled.div`
  position: relative;
  display: flex;
  padding-left: 20px;
  background-color: #ffecf2;
  color: #ff4080;
  padding: 14px 20px;
  img {
    margin-right: 16px;
    flex-shrink: 0;
  }
  :before {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    width: 4px;
    height: 100%;
    background-color: #ff4080;
  }
`

const Notification = () => {
  return (
    <>
      <Heading>Notification</Heading>
      <NotificationSection>
        <img src="/images/error-icon.svg" alt="" />
        <Paragraph>Error: all fields required</Paragraph>
      </NotificationSection>
    </>
  )
}

export default Notification
